/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 18C9 18 10 18.5 12 18.5M12 18.5C14 18.5 15 18 15 18M12 18.5V14"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 2C7.58172 2 4 5.58172 4 10C4 12.9482 6.2263 15.3013 7.70778 16.5408C8.47633 17.1838 9 18.1102 9 19.1123C9 20.7071 10.2929 22 11.8877 22H12.1268C13.7136 22 15 20.7136 15 19.1268C15 18.1175 15.5342 17.1861 16.3119 16.5427C17.7933 15.317 20 12.9895 20 10C20 5.58172 16.4183 2 12 2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 2C7.58172 2 4 5.58172 4 10C4 13.6388 7.39141 16.371 8.58805 17.2218C8.84131 17.4019 9 17.6892 9 18C9 18 10 18.5 12 18.5C14 18.5 15 18 15 18C15 17.6898 15.1604 17.4034 15.4149 17.2261C16.6141 16.3904 20 13.7031 20 10C20 5.58172 16.4183 2 12 2Z"
				fill="currentColor"
			/>
			<path
				d="M9 18C9 18 10 18.5 12 18.5M12 18.5C14 18.5 15 18 15 18M12 18.5V14M20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 12.9482 6.2263 15.3013 7.70778 16.5408C8.47633 17.1838 9 18.1102 9 19.1123V19.1123C9 20.7071 10.2929 22 11.8877 22H12.1268C13.7136 22 15 20.7136 15 19.1268V19.1268C15 18.1175 15.5342 17.1861 16.3119 16.5427C17.7933 15.317 20 12.9895 20 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M17.4825 16.5107C17.2312 16.7463 17.1056 16.8641 16.9095 16.9783C16.7531 17.0694 16.5276 17.1586 16.3512 17.1991C16.13 17.25 15.9212 17.25 15.5036 17.25H14.35C13.7899 17.25 13.5099 17.25 13.296 17.141C13.1078 17.0451 12.9549 16.8922 12.859 16.704C12.75 16.4901 12.75 16.2101 12.75 15.65V14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V15.65C11.25 16.2101 11.25 16.4901 11.141 16.704C11.0451 16.8922 10.8922 17.0451 10.704 17.141C10.4901 17.25 10.2101 17.25 9.65 17.25H8.52659C8.10526 17.25 7.89459 17.25 7.67238 17.1987C7.49459 17.1576 7.26927 17.068 7.11182 16.9757C6.91502 16.8605 6.78788 16.7404 6.53359 16.5001C6.34368 16.3207 6.14939 16.1278 5.9549 15.922C4.65363 14.545 3.25 12.4922 3.25 10C3.25 5.16751 7.16751 1.25 12 1.25C16.8325 1.25 20.75 5.16751 20.75 10C20.75 12.5312 19.3486 14.584 18.0431 15.9547C17.8548 16.1525 17.6666 16.338 17.4825 16.5107Z"
				fill="currentColor"
			/>
			<path
				d="M15.75 18.75H8.25V19C8.25 21.0711 9.92893 22.75 12 22.75C14.0711 22.75 15.75 21.0711 15.75 19V18.75Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M5.75463 5C4.65672 6.3696 4 8.10811 4 10C4 12.9482 6.2263 15.3013 7.70778 16.5408C8.47633 17.1838 9 18.1102 9 19.1123V19.1123C9 20.7071 10.2929 22 11.8877 22H12.1268C13.7136 22 15 20.7136 15 19.1268V19.1268C15 18.1175 15.5342 17.1861 16.3119 16.5427C17.7933 15.317 20 12.9895 20 10C20 5.58172 16.4183 2 12 2C10.9391 2 9.92643 2.20651 9 2.58152M9 18C9 18 10 18.5 12 18.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 18C9 18 10 18.5 12 18.5M12 18.5C14 18.5 15 18 15 18M12 18.5V14M20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 12.9482 6.2263 15.3013 7.70778 16.5408C8.47633 17.1838 9 18.1102 9 19.1123V19.1123C9 20.7071 10.2929 22 11.8877 22H12.1268C13.7136 22 15 20.7136 15 19.1268V19.1268C15 18.1175 15.5342 17.1861 16.3119 16.5427C17.7933 15.317 20 12.9895 20 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M5.9549 15.922C6.14939 16.1278 6.34368 16.3207 6.53359 16.5001C6.78788 16.7404 6.91502 16.8605 7.11182 16.9757C7.26927 17.068 7.49459 17.1576 7.67238 17.1987C7.89459 17.25 8.10526 17.25 8.52659 17.25H15.5036C15.9212 17.25 16.13 17.25 16.3512 17.1991C16.5276 17.1586 16.7531 17.0694 16.9095 16.9783C17.1056 16.8641 17.2312 16.7463 17.4825 16.5107L17.4825 16.5107C17.6666 16.338 17.8548 16.1525 18.0431 15.9547C19.3486 14.584 20.75 12.5312 20.75 10C20.75 5.16751 16.8325 1.25 12 1.25C7.16751 1.25 3.25 5.16751 3.25 10C3.25 12.4922 4.65363 14.545 5.9549 15.922Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V14ZM8.25 19V18.75H15.75V19C15.75 21.0711 14.0711 22.75 12 22.75C9.92893 22.75 8.25 21.0711 8.25 19Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
